<template>
  <h3 class="panel-row-action-menu-heading">
    <slot />
  </h3>
</template>
